
export default "/assets/check-circle-micro.73a7c791.svg"